import React from 'react'
import { Line } from 'react-konva'

import { Line as LineInterface } from '../../../reducers/editPhoto'
import { getSquareLinePoints } from '../../../utils/geometryCalculations'

interface SquareLineProps {
    line: LineInterface
    stroke?: string
    fill?: string
    opacity?: number
}

/**
 * 四角形のブラシストロークを描画するコンポーネント
 */
export const SquareLine: React.FC<SquareLineProps> = ({
    line,
    stroke = 'black',
    fill = 'black',
    opacity = 1
}) => {
    const { points, headSize } = line
    const shapes: React.ReactElement[] = []

    // points配列を2つずつ（x, y）処理して、連続する四角形を生成
    for (let i = 0; i < points.length; i += 2) {
        const x1 = points[i]
        const y1 = points[i + 1]
        const x2 = points[i + 2]
        const y2 = points[i + 3]

        // 次の座標がない場合は終了
        if (x2 === undefined) break

        const outputPoints = getSquareLinePoints(x1, y1, x2, y2, headSize)

        shapes.push(
            <Line
                key={i}
                points={outputPoints}
                stroke={stroke}
                fill={fill}
                strokeWidth={0}
                tension={0}
                opacity={opacity}
                closed
                lineCap="round"
            />
        )
    }

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{shapes}</>

}
